<template>
    <div>
        <el-page-header @back="goBack" content="添加活动">
        </el-page-header>
        <el-card class="form-container" shadow="never">
            <el-form :model="piece" :rules="rules" ref="pieceFrom" label-width="150px">
                <el-form-item label="活动名称：" prop="name">
                    <el-input v-model="piece.name"></el-input>
                </el-form-item>
                <el-form-item label="活动类型：">
                    <el-select  v-model="piece.activityType" placeholder="请选择">
                        <el-option
                                v-for="item in types"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="活动周期：">
                    <el-select  v-model="piece.circleType" placeholder="请选择">
                        <el-option
                                v-for="item in options"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="活动备注：">
                    <el-input
                            placeholder="请输入内容"
                            type="textarea"
                            v-model="piece.detail">
                    </el-input>
                </el-form-item>
                <el-form-item label="是否显示：">
                    <el-radio-group v-model="piece.isUse">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="confirm('pieceFrom')" >提交</el-button>
                    <el-button type="primary" @click="reset('pieceFrom')" >重置</el-button>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>

<script>
    const defaultPiece={
      id:0,
      name:'',
      circleType:1,
      detail:'',
      isUse:0
    };
    import {
        allSelectData,
        savePieceActivity,
    } from "@/http/api";
    export default {
        name: "PieceActivity",
        data(){
            return{
                piece:Object.assign({}, defaultPiece),
                rules: {
                    name: [
                        {required: true, message: '请输入活动名称', trigger: 'blur'},
                        {min: 2, max: 30, message: '长度在 2 到 30 个字符', trigger: 'blur'}
                    ]
                },
                options:[],
                types:[],
            }
        },
        methods:{
            goBack() {
               this.$router.push({name: 'ActivityConfig',params:{activeName:'second'}})
            },
            confirm(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$confirm('是否提交数据', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                                savePieceActivity(this.piece).then(resp => {
                                    if (resp.data.status === 0 ){
                                        this.$refs[formName].resetFields();
                                        this.piece = Object.assign({},defaultPiece);
                                        this.$message({
                                            message: '提交成功',
                                            type: 'success',
                                            duration:1000
                                        });
                                    }
                                });
                        });
                    } else {
                        this.$message({
                            message: '验证失败',
                            type: 'error',
                            duration:1000
                        });
                        return false;
                    }
                });
            },
            reset(formName) {
                this.$refs[formName].resetFields();
                this.piece = Object.assign({},defaultPiece);
            }
        },
        created() {
            allSelectData().then(resp =>{
                this.options = resp.data.info.activityCircleTypes;
                this.types = resp.data.info.dailyActivityTypes;
            });
        }
    }
</script>

<style scoped>
    .form-container {
        position: absolute;
        left: 0;
        right: 0;
        width: 720px;
        padding: 35px 35px 15px 35px;
        margin: 20px auto;
    }
</style>